module.exports = __webpack_public_path__ + "media/images/country_flags/sr-dae3e535515eb85bae09538be2e94ec7.png";